export const NO_INSURED_ARS_ID = 27;

export const isNoInsuredArs = (arsId) =>
  Number(arsId) === NO_INSURED_ARS_ID;

export const ensureNoInsuredArs = (arses = []) => {
  const normalizedArses = Array.isArray(arses) ? arses : [];
  const currentNoInsured = normalizedArses.find((item) =>
    isNoInsuredArs(item?.arsId),
  );
  const otherArses = normalizedArses.filter(
    (item) => !isNoInsuredArs(item?.arsId),
  );

  return [
    {
      ...(currentNoInsured || {}),
      arsId: NO_INSURED_ARS_ID,
      enabled: true,
      codePSS: null,
      codeUserPSS: null,
      codePP: null,
      discountPP: currentNoInsured?.discountPP || 0,
    },
    ...otherArses,
  ];
};
